import Logo from "../assets/images/logo.svg";
import LogoHome from "../assets/images/logo-home-1.png";
import Collapsed from "../assets/images/ico collapse.png";
import Expand from "../assets/images/ico expand.png";
import HomeBuilderAc from "../assets/images/ico home builder ac.png";
import HomeBuilderDe from "../assets/images/ico home builder de.png";
import TierAc from "../assets/images/ico tier ac.png";
import TierDe from "../assets/images/ico tier de.png";
import SuperModAc from "../assets/images/ico super mod ac.png";
import SuperModDe from "../assets/images/ico super mod de.png";
import UserAc from "../assets/images/ico user ac.png";
import UserDe from "../assets/images/ico user de.png";
import SettingAc from "../assets/images/ico setting ac.png";
import SettingDe from "../assets/images/ico setting de.png";
import LogoutAc from "../assets/images/ico logout ac.png";
import LogoutDe from "../assets/images/ico logout de.png";
import Badge from "../assets/images/ico badge.png";
import Badge_2 from "../assets/images/ico badge 2.svg";
import Search from "../assets/images/ico search.png";
import Add from "../assets/images/ico add.png";
import Close from "../assets/images/ico close.png";
import EyeSplash from "../assets/images/ico_eye_splash.png";
import Eye from "../assets/images/ico_eye.png";
import DropDown from "../assets/images/icon dropdown.png";
import Transfer from "../assets/images/ico transfer.svg";
import Reset from "../assets/images/ico reset.png";
import MenuBar_Res from "../assets/images/ico menu bar responsive.png";
import Waiting_Sta from "../assets/images/waiting.png";
import Pics from "../assets/images/ico image.png";
import Remove from "../assets/images/ico trash.png";
import CompanyDe from "../assets/images/ico company de.png";
import CompanyAc from "../assets/images/ico company ac.png";
import HomeBuyerBlack from "../assets/images/ico-home-buyer-black.svg";
import HomeBuyerDe from "../assets/images/ico home buyer de.png";
import HomeBuyerAc from "../assets/images/ico home buyer ac.png";
import TransferHB from "../assets/images/transfer homebuyer.png";
import TransferHB_Comp from "../assets/images/ico transfer hb.svg";
import Logo1 from "../assets/images/PD_login.svg";
import LogoHome1 from "../assets/images/PD_logo.svg";
import LogoComp from "../assets/images/logo_comp.jpg";
import LogoCompProfile from "../assets/images/pd-logo.jpg";
import MenuAC from "../assets/images/ico-menu-dummy-ac.png";
import MenuDE from "../assets/images/ico-menu-dummy-de.png";
import FilterDE from "../assets/images/ico-filter-de.png";
import HomeAC from "../assets/images/ico-home-ac.svg";
import HomeDE from "../assets/images/ico-home-de.svg";
import SelectionAC from "../assets/images/ico-selection-ac.svg";
import SelectionDE from "../assets/images/ico-selection-de.svg";
import MaterialAC from "../assets/images/ico-material-ac.svg";
import MaterialDE from "../assets/images/ico-material-de.svg";
import ProductBlack from "../assets/images/ico-material-black.svg";
import ProductAC from "../assets/images/ico-material-ac.svg";
import ProductDE from "../assets/images/ico-material-de.svg";
import SignInMicrosoftButton from "../assets/images/signin-microsoft-button-light.png";
import IconPlay from "../assets/images/ic-play.png";
import IconPlayHover from "../assets/images/ic-play-hover.png";
import HenleyLogo from "../assets/images/logo_comp.jpg";
import PoweredByAwayLogo from "../assets/images/logo home.png";
import LoadingBackground from "../assets/images/loading-image.png";
import EyeInvisible from "../assets/images/ico-eye-invisible.svg";
import EyeInvisibleBlack from "../assets/images/ico-eye-invisible-black.svg";
import EyeInvisibleWhite from "../assets/images/ico-eye-invisible-white.svg";
import Thumbnail from "../assets/images/ico-thumbnail.svg";
import ThumbnailBlack from "../assets/images/ico-thumbnail-black.svg";
import ThumbnailWhite from "../assets/images/ico-thumbnail-white.svg";
import EditBlack from "../assets/images/ico-edit-black.svg";
import EditWhite from "../assets/images/ico-edit-white.svg";
import CheckBlue from "../assets/images/ico-check-blue.svg";
import CheckWhite from "../assets/images/ico-check-white.svg";
import UndoBlack from "../assets/images/ico-undo-black.svg";
import DefaultThumbnail from "../assets/images/img-default-thumbnail.png";
import Palette from "../assets/images/ico-palette.svg";
import PaletteHover from "../assets/images/ico-palette-hover.svg";
import PaletteBlack from "../assets/images/ico-palette-black.svg";

export const Images = {
  LOGO: Logo,
  LOGO1: Logo1,
  EXPAND: Expand,
  COLLAPSED: Collapsed,
  HOME_BUILDER_AC: HomeBuilderAc,
  HOME_BUILDER_DE: HomeBuilderDe,
  TIER_AC: TierAc,
  TIER_DE: TierDe,
  SUPER_MOD_AC: SuperModAc,
  SUPER_MOD_DE: SuperModDe,
  USER_AC: UserAc,
  USER_DE: UserDe,
  SETTING_AC: SettingAc,
  SETTING_DE: SettingDe,
  LOG_OUT_AC: LogoutAc,
  LOG_OUT_DE: LogoutDe,
  BADGE: Badge,
  BADGE_2: Badge_2,
  SEARCH: Search,
  ADD: Add,
  CLOSE: Close,
  LOGO_HOME: LogoHome,
  LOGO_HOME1: LogoHome1,
  EYE_SPLASH: EyeSplash,
  EYE: Eye,
  DROPDOWN: DropDown,
  TRANSFER: Transfer,
  RESET: Reset,
  MENUBAR_RES: MenuBar_Res,
  WAITING_STA: Waiting_Sta,
  PICS: Pics,
  REMOVE: Remove,
  COMPANY_DE: CompanyDe,
  COMPANY_AC: CompanyAc,
  HOMEBUYER_BLACK: HomeBuyerBlack,
  HOMEBUYER_DE: HomeBuyerDe,
  HOMEBUYER_AC: HomeBuyerAc,
  TRANSFER_HB: TransferHB,
  LOGO_COMP: LogoComp,
  TRANSFER_HB_COMP: TransferHB_Comp,
  LOGOCOMPPROFILE: LogoCompProfile,
  MENU_AC: MenuAC,
  MENU_DE: MenuDE,
  FILTER_DE: FilterDE,
  HOME_AC: HomeAC,
  HOME_DE: HomeDE,
  SELECTION_AC: SelectionAC,
  SELECTION_DE: SelectionDE,
  MATERIAL_AC: MaterialAC,
  MATERIAL_DE: MaterialDE,
  PRODUCT_BLACK: ProductBlack,
  PRODUCT_AC: ProductAC,
  PRODUCT_DE: ProductDE,
  SIGNIN_MICROSOFT_BUTTON: SignInMicrosoftButton,
  ICON_PLAY: IconPlay,
  ICON_PLAY_HOVER: IconPlayHover,
  HENLEY_LOGO: HenleyLogo,
  POWERED_BY_AWAY_LOGO: PoweredByAwayLogo,
  LOADING_BACKGROUND: LoadingBackground,
  EYE_INVISIBLE: EyeInvisible,
  EYE_INVISIBLE_BLACK: EyeInvisibleBlack,
  EYE_INVISIBLE_WHITE: EyeInvisibleWhite,
  THUMBNAIL: Thumbnail,
  THUMBNAIL_BLACK: ThumbnailBlack,
  THUMBNAIL_WHITE: ThumbnailWhite,
  EDIT_BLACK: EditBlack,
  EDIT_WHITE: EditWhite,
  CHECK_BLUE: CheckBlue,
  CHECK_WHITE: CheckWhite,
  UNDO_BLACK: UndoBlack,
  DEFAULT_THUMBNAIL: DefaultThumbnail,
  PALETTE: Palette,
  PALETTE_HOVER: PaletteHover,
  PALETTE_BLACK: PaletteBlack,
};
